import { styled } from '@mui/material';
import { Text } from '../../../base/Text';
import { colorPalettes } from '../../../../context/theme';
import { SIZES, LINE_HEIGHT, PADDING } from '../../../../constants/sizes';

export const StyledUserDetails = styled.div`
  padding: ${PADDING['x-x-x-x-large']} 0 0;
  text-align: center;

  & .topbar-avatar {
    width: 7rem;
    height: 7rem;
    margin: auto;

    & .topbar-avatar-name {
      font-size: ${SIZES['x-x-large']};
      padding: ${PADDING['x-x-x-x-large']} 0;
      cursor: default;
    }

    & .topbar-avatar-image {
      cursor: default;
    }
  }
`;

export const StyledUserDetailsName = styled(Text)`
  color: ${({ theme }) =>
    colorPalettes[theme.palette.mode].components.accountSettings.avatar.text};
  font-size: ${SIZES['large']};
  font-weight: 400;
  line-height: ${LINE_HEIGHT['large']};
  text-align: center;
  padding-top: 1rem;
`;

export const StyledUserDetailsEmail = styled(Text)`
  color: ${({ theme }) =>
    colorPalettes[theme.palette.mode].components.accountSettings.avatar.text};
  font-size: ${SIZES['small']};
  font-weight: 400;
  line-height: ${LINE_HEIGHT['small']};
  text-align: center;
  padding-top: ${PADDING['small']};
`;

export const StyledUserDetailsOrgName = styled.div`
  & .org-details {
    padding: ${PADDING['x-large']} 0 ${PADDING['large']};
    justify-content: center;
  }
`;
